import { AppThunk } from '../../../../store/types';
import { MainLayoutEffects } from '../../../../effects/mainLayoutEffects';
import { Navigator } from '../../../../effects/navigator';
import { setMainViewMode, setSnackbarPanelAction } from '../../../../store/general/actions';
import { EMainViewMode } from '../../../../store/general/types';
import { ContentLibActions } from '../../../../store/contentLib/actions';
import { EContentLibViewMode } from '../../../../store/contentLib/types';
import { isLoggedUser } from '../../../../store/general/selectors';
import { LoginPopupActions } from '../../../../store/loginPopup/actions';
import { CopyVideoEffects } from '../../../../effects/copyVideoEffects';
import { CopyGroupEffects } from '../../../../effects/copyGroupEffects';
import { getActiveGroupId } from '../../../../store/models/selectors';
import { getCurrentMovieKey } from '../../../../store/current-video/selectors';

export class MenuWidgetsEvents {

	public static onShowHelp(): AppThunk {
		return (
			dispatch,
			getState
		) => {
			dispatch(MainLayoutEffects.showHelp());
		}
	}

	public static onClickMyLibrary (): AppThunk {
		return (
		  dispatch,
		  getState,
		) => {
			const callback = () => {
				Navigator.openMyStuff();
				dispatch(setMainViewMode(EMainViewMode.MY_LIBRARY));
				dispatch(ContentLibActions.setViewMode(EContentLibViewMode.GROUP_LIST));
			}

			if (!isLoggedUser(getState())) {
				dispatch(LoginPopupActions.set({
					show: true,
					text: 'Please login to save your videos',
					onLogin: callback,
				}));
				return;
			}

			callback();
		}
	}
	
	public static onClickContent (): AppThunk {
		return (
			dispatch,
		) => {
			Navigator.openContentLib();
			dispatch(setMainViewMode(EMainViewMode.CONTENT_LIBRARY));
			dispatch(ContentLibActions.setViewMode(EContentLibViewMode.VIDEO_LIST));
		}
	}

	public static onClickRecent (): AppThunk {
		return async (
			dispatch,
		) => {
			Navigator.openVideoRecent();
     		dispatch(setMainViewMode(EMainViewMode.DASHBOARD));
		}
	}

	public static onClickSettings (): AppThunk {
		return (
		  dispatch
		) => {
		  Navigator.openSettings();
		}
	}

	public static onCopyLinkVideo (
	): AppThunk {
		return async (
			dispatch,
			getState
		) => {
			const groupId = getActiveGroupId(getState());
			if (!groupId) {
				return dispatch(setSnackbarPanelAction(true, 'Unable create copy link: invalid playlist'));
			}
			const videoId = getCurrentMovieKey(getState());
			const url = await CopyVideoEffects.createCopyLink(videoId, groupId);
			await navigator.clipboard.writeText(url);
			dispatch(setSnackbarPanelAction(true, 'Public link to video copied to clipboard'));
		}
	}

	public static onCopyLinkPlaylist (
	): AppThunk {
		return async (
			dispatch,
			getState
		) => {
			const groupId = getActiveGroupId(getState());
			if (!groupId) {
				return dispatch(setSnackbarPanelAction(true, 'Unable create copy link: invalid playlist'));
			}
			const {url} = await CopyGroupEffects.createCopyLink(groupId);
			await navigator.clipboard.writeText(url);
			dispatch(setSnackbarPanelAction(true, 'Public link to playlist copied to clipboard'));
		}
	}

}